export default __webpack_public_path__ + "static/media/undraw_sentiment-analysis_rke9.1f737fbd.svg";